import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import MorphSVGPlugin from 'gsap/MorphSVGPlugin';



function whoweserve() {
    const who_we_serve = document.querySelector('[data-target="who_we_serve"]');
    if (!who_we_serve) { return; }

 
    const links = who_we_serve.querySelectorAll('[data-target="who_we_serve_link"]');
    const images = who_we_serve.querySelectorAll('[data-target="who_we_serve_image"]');

    gsap.set(images[0], {
        opacity: 1
    });

    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    
    links.forEach((link, index) => {
        if (isMobile) {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                gsap.to(images, {
                    opacity: 0,
                    duration: 0.3
                });
                
                gsap.to(images[index], {
                    opacity: 1,
                    duration: 0.3,
                    onComplete: () => {
                        window.location.href = link.href;
                    }
                });
            });
        } else {
            link.addEventListener('mouseenter', () => {
                gsap.to(images, {
                    opacity: 0,
                    duration: 0.3
                });
                
                gsap.to(images[index], {
                    opacity: 1,
                    duration: 0.3
                });
            });
        }
    });

    // const who_we_serve_pin = document.querySelector('[data-target="who_we_serve_pin"]');
    
    // const paddingleft = who_we_serve_cont.getBoundingClientRect().left;
    // who_we_serve_pin.style.paddingLeft = `${paddingleft}px`;

    // const sections = gsap.utils.toArray('[data-target="who_we_serve_box"]');


    // gsap.from(sections, {
    //     autoAlpha: 0,
    //     duration: 1.8,
    //     scrollTrigger: {
    //         trigger: who_we_serve_pin,
    //         start:'top 70%'
        
    //     },
    // });
    // gsap.from(who_we_serve_cont, {
    //     autoAlpha: 0,
    //     duration: 1.8,
    //     scrollTrigger: {
    //         trigger: who_we_serve_cont,
    //         start:'top 70%'
        
    //     },
    // });


    // let maxWidth = 0;

    // const getMaxWidth = () => {
    //     maxWidth = 0;
    //     sections.forEach((section) => {
    //         maxWidth += section.offsetWidth;
    //     });
    // };
    // getMaxWidth();
    // ScrollTrigger.addEventListener("refreshInit", getMaxWidth);

    
    
    // let horizontalscroll;
    // function initHorizontalScroll() {
    //     if (window.innerWidth > 1279) {
    //         horizontalscroll = gsap.to(sections, {
    //             x: () => -1 * (who_we_serve_pin.scrollWidth - innerWidth + paddingleft),
    //             ease: "none",
    //             scrollTrigger: {
    //                 trigger: who_we_serve,
    //                 pin: true,
    //                 scrub: true,
    //                 start: 'center center',
    //                 invalidateOnRefresh: true,
    //                 end: () =>  "+=" + (who_we_serve_pin.scrollWidth - innerWidth + paddingleft)
    //             }
    //         });
    //     } else if (horizontalscroll) {
    //         horizontalscroll.kill();
    //         horizontalscroll = null;
    //     }
    // }

    // initHorizontalScroll();
    // window.addEventListener('resize', initHorizontalScroll);



      
    //   const who_we_serve_boxes = document.querySelectorAll('[data-target="who_we_serve_box"]');
    //   who_we_serve_boxes.forEach(function(who_we_serve_box) {
      
    //       const paragraph = who_we_serve_box.querySelector('p');
    //       const link_bubble = who_we_serve_box.querySelector('[data-target="link_bubble"]');
      
    //       const step1 = who_we_serve_box.querySelector('.step1');
    //       const step2 = who_we_serve_box.querySelector('.step2');
      
    //       const cornerGreenLeft = who_we_serve_box.querySelector("[data-target='corner_green_left']");
    //       const cornerGreenRight = who_we_serve_box.querySelector("[data-target='corner_green_right']");
    //       const absoluteBox = who_we_serve_box.querySelector(".absolute.bottom-0.left-0.z-10"); 
      
    //       let tl, tlback;
      
          
    //       function updateCornerPositions() {
    //           if (absoluteBox && cornerGreenLeft && cornerGreenRight) {
    //               const boxTop = absoluteBox.offsetTop;
    //               const boxLeft = absoluteBox.offsetLeft;
    //               const boxWidth = absoluteBox.offsetWidth;
    //               const boxHeight = absoluteBox.offsetHeight;
      
                  
    //               cornerGreenLeft.style.top = `${boxTop - 1}px`;  
    //               cornerGreenRight.style.left = `${boxLeft + boxWidth - 20}px`;  
    //           }
    //       }
    //       const isDesktop = window.innerWidth > 1279;
    //       function handleInteraction(isMouseOver) {
             

    //           if (isDesktop) {
    //               if (isMouseOver) {
    //                   if (tlback && tlback.isActive()) {
    //                       tlback.kill();
    //                   }

    //                   tl = gsap.timeline({
    //                       onUpdate: updateCornerPositions,
    //                       onComplete: updateCornerPositions
    //                   });

    //                   tl.to(paragraph, {height: "auto", duration: 0.5}, "start")
    //                     .to(link_bubble, {scale: 1, x: 55, y: -55, duration: 0.5}, "start")
    //                     .to(step2, { duration: 0.5, ease: "power2.out", morphSVG: {
    //                         shape: step1,
    //                         shapeIndex: 3,
    //                         map: "complexity",
    //                         precision: 5
    //                     }}, "start")
    //                     .call(updateCornerPositions);
    //               } else {
    //                   if (tl && tl.isActive()) {
    //                       tl.kill();
    //                   }

    //                   tlback = gsap.timeline({
    //                       onUpdate: updateCornerPositions,
    //                       onComplete: updateCornerPositions
    //                   });

    //                   tlback.to(paragraph, {height: "0", duration: 0.5})
    //                         .to(link_bubble, {scale: 0, duration: 0.3}, "end-=0.5")
    //                         .to(link_bubble, {x: 40, y: -40, duration: 0.6}, "end-=0.5")
    //                         .call(updateCornerPositions);
    //               }
    //           } 
    //       }

    //       who_we_serve_box.addEventListener('mouseover', () => handleInteraction(true));
    //       who_we_serve_box.addEventListener('mouseout', () => handleInteraction(false));

    //       updateCornerPositions();

    //       if (isDesktop) {
    //       }else {
    //         if (absoluteBox && cornerGreenLeft && cornerGreenRight) {
    //             const boxTop = absoluteBox.offsetTop;
    //             const boxLeft = absoluteBox.offsetLeft;
    //             const boxWidth = absoluteBox.offsetWidth;
    //             const boxHeight = absoluteBox.offsetHeight;
    
                
    //             cornerGreenLeft.style.top = `${boxTop - 1}px`;  
    //             cornerGreenRight.style.left = `${boxLeft + boxWidth - 20}px`;  
    //         }
    //         gsap.set(paragraph, {height:  "auto"});
    //         gsap.set(link_bubble, {
    //             scale:  1 ,
    //             x:  55 ,
    //             y:  -55 
    //         });
    
    //         }
    //   });
      

   
            
       
        

    
    
}


export { whoweserve }; 